import organisationUnits from "./organisation-reasons";

export const ORGANISATION_REASONS_NAMESPACE = `organisations/organisationReasons`;

export default organisationUnits;
